'use es6';

import createAction from 'flux-actions/createAction';
import { FETCHED_ADS_DATA, REQUESTED_ADS_DATA, RECEIVED_ADS_DATA, REQUESTED_ADS_DATA_FAILED } from './ActionTypes';
export const fetchAdsData = createAction(FETCHED_ADS_DATA);
export const requestAdsData = createAction(REQUESTED_ADS_DATA);
export const receiveAdsData = createAction(RECEIVED_ADS_DATA, data => ({
  data
}));
export const requestAdsDataFailed = createAction(REQUESTED_ADS_DATA_FAILED, error => ({
  error
}));